 
export class CotacaoVM {
    operadora!: string
    fonte!: string
    campanha!: string
    canal!: string
    descricaoProduto!: string
    idVendedor!: string
    pessoa!: Pessoa
    idProfissao!: string
    dependente!: number
    dependentes!: string[]
    contato!: string
    idEstado!: string
    idCidade!: string
    preferenciaContato!: string
    checkObrigatorio!: string
    email!: string
  }
  
  export class Pessoa {
    nomeCompleto!: string
    // email!: string
    dataNascimento!: string
  }
  